import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useLogout } from '@/hooks/useAuth';
import { useAuthStore } from '@/stores/auth';

/** A guardian's account: who is signed in, and signing out. */
export default function GuardianAccountPage() {
  const user = useAuthStore((s) => s.user);
  const logout = useLogout();

  return (
    <>
      <Helmet>
        <title>Conta | AICD</title>
      </Helmet>
      <div className="space-y-6">
        <header>
          <h1 className="text-2xl font-black text-foreground">Conta</h1>
          <p className="mt-1 subtitle text-sm text-muted-foreground">Encarregado de Educação</p>
        </header>

        <dl className="space-y-3 rounded-2xl border border-border bg-card p-4 shadow-sm">
          <div>
            <dt className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Nome</dt>
            <dd className="text-sm font-bold text-foreground">{user?.name}</dd>
          </div>
          <div>
            <dt className="text-xs font-bold uppercase tracking-widest text-muted-foreground">Email</dt>
            <dd className="text-sm text-foreground">{user?.email}</dd>
          </div>
        </dl>

        <p className="text-xs text-muted-foreground">
          Para alterar os seus dados ou os educandos associados à sua conta, fale com a equipa do
          Centro.
        </p>

        <Link
          to="/privacidade"
          className="flex items-center justify-between rounded-2xl border border-border bg-card p-4 text-sm font-bold text-foreground shadow-sm hover:bg-accent"
        >
          Privacidade e os seus dados
          <svg className="h-5 w-5 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>

        <button
          type="button"
          onClick={() => logout.mutate()}
          disabled={logout.isPending}
          className="btn-outline w-full"
        >
          {logout.isPending ? 'A terminar sessão…' : 'Terminar sessão'}
        </button>
      </div>
    </>
  );
}
